import { auth } from "./setup";
import { GoogleAuthProvider } from "firebase/auth";
import { signInWithPopup } from "firebase/auth";

/**************
 * google auth *
 **************/
export const provider = new GoogleAuthProvider();
provider.addScope("https://www.googleapis.com/auth/contacts.readonly");
provider.setCustomParameters({
  hd: "porchpass.com",
});

export const signInWithGoogle = async () => {
  try {
    const result = await signInWithPopup(auth, provider);
    if (!result.user?.email?.endsWith("@porchpass.com")) {
      throw new Error("admin access not allowed");
    }
    return result.user;
  } catch (error) {
    console.error("SIGNIN WITH POPUP ERROR:", error);
    throw error;
  }
};
